import React, { useState } from 'react';

const InteractiveAccordion = ({ items, allowMultiple = false }) => {
  const [openItems, setOpenItems] = useState([]);

  const toggleItem = (index) => {
    if (allowMultiple) {
      setOpenItems(prev =>
        prev.includes(index)
          ? prev.filter(i => i !== index)
          : [...prev, index]
      );
    } else {
      setOpenItems(prev => prev.includes(index) ? [] : [index]);
    }
  };

  return (
    <div className="space-y-4">
      {items.map((item, index) => (
        <div
          key={index}
          className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300"
        >
          <button
            onClick={() => toggleItem(index)}
            className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-secondary-50 transition-colors duration-200"
          >
            <div className="flex items-center space-x-4">
              {item.icon && <span className="text-2xl">{item.icon}</span>}
              <h3 className="text-lg font-semibold text-secondary-900">{item.title}</h3>
            </div>
            <div className={`transform transition-transform duration-200 ${openItems.includes(index) ? 'rotate-180' : ''}`}>
              <svg className="w-5 h-5 text-primary-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </div>
          </button>

          <div className={`overflow-hidden transition-all duration-300 ${
            openItems.includes(index) ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
          }`}>
            <div className="px-6 pb-4">
              <p className="text-secondary-600 leading-relaxed">{item.content}</p>
              {item.details && (
                <div className="mt-4 space-y-2">
                  {item.details.map((detail, detailIndex) => (
                    <div key={detailIndex} className="flex items-start space-x-2">
                      <span className="text-primary-600 mt-1">•</span>
                      <span className="text-secondary-700">{detail}</span>
                    </div>
                  ))}
                </div>
              )}
              {item.cta && (
                <div className="mt-4">
                  <button className="btn-primary">
                    {item.cta}
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default InteractiveAccordion;